import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { ApiMerchant } from '../models/merchant/merchant.interface';
import { environment } from '../../environments/environment'
import { tap } from 'rxjs/operators';

const { baseUrl } = environment;

@Injectable({
  providedIn: 'root'
})
export class MerchantService {

  constructor(private httpClient: HttpClient) { }

  MerchantStateMachine(authToken: string, merchantId: string): Observable<ApiMerchant> {
    const url = `${baseUrl}/merchant/${merchantId}`;

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      })
    };

    const response = this.httpClient.get<ApiMerchant>(
      url,
      httpOptions
    ).pipe(
      tap((merchantData: ApiMerchant) => {
        try {
          console.log('merchantData recibido:', merchantData);

          if (merchantData) {
            if (merchantData.merchant_identification_number) {
              localStorage.setItem('merchant_identification_number', merchantData.merchant_identification_number);
            }
            if (
              merchantData.address &&
              merchantData.address.length > 0 &&
              merchantData.address[0].address &&
              merchantData.address[0].address_line_1
            ) {
              const addressValue = merchantData.address[0].address;
              const addressLineValue = merchantData.address[0].address_line_1;
              localStorage.setItem('merchant_address', addressValue);
              localStorage.setItem('merchant_address_line', addressLineValue);
            } else {
              console.warn('No existe address[0].address para guardar.');
            }
          if (merchantData.requires_rendition !== undefined) {
            localStorage.setItem('requires_rendition', String(merchantData.requires_rendition));
          }
          }
        } catch (error) {
          console.error('Error en tap:', error);
        }
      })
    );
    console.log(response);
    return response;
  }
}